module.exports = __webpack_public_path__ + "img/phoneAuthentication.82bbe7af.svg";